const CACHE_TTL_MS = 60 * 60 * 1000;
const SAMPLE_BLOCK_LOOKBACK = 100;
const FALLBACK_BLOCK_TIME_SECONDS = 13.5;

let blockTimeCache = {
  avgBlockTimeSeconds: FALLBACK_BLOCK_TIME_SECONDS,
  fetchedAt: 0,
};

let refreshPromise = null;

const refreshAverageBlockTime = async (web3Instance) => {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    try {
      const latestBlock = await web3Instance.eth.getBlock("latest");
      const sampleBlockNumber = Math.max(
        0,
        parseInt(latestBlock.number, 10) - SAMPLE_BLOCK_LOOKBACK
      );
      const sampleBlock = await web3Instance.eth.getBlock(sampleBlockNumber);
      const blockDelta =
        parseInt(latestBlock.number, 10) - parseInt(sampleBlock.number, 10);

      if (blockDelta <= 0) {
        return blockTimeCache.avgBlockTimeSeconds;
      }

      const avgBlockTimeSeconds =
        (parseInt(latestBlock.timestamp, 10) -
          parseInt(sampleBlock.timestamp, 10)) /
        blockDelta;

      blockTimeCache = {
        avgBlockTimeSeconds,
        fetchedAt: Date.now(),
      };

      return avgBlockTimeSeconds;
    } catch (error) {
      console.log("Failed to refresh average block time", error);
      return blockTimeCache.avgBlockTimeSeconds;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};

export const getAverageBlockTimeSeconds = async (web3Instance) => {
  const cacheIsFresh =
    blockTimeCache.fetchedAt &&
    Date.now() - blockTimeCache.fetchedAt < CACHE_TTL_MS;

  if (cacheIsFresh) {
    return blockTimeCache.avgBlockTimeSeconds;
  }

  return refreshAverageBlockTime(web3Instance);
};

export const estimateProposalEndTimestamp = async (web3Instance, endBlock) => {
  const targetBlock = parseInt(endBlock, 10);

  if (Number.isNaN(targetBlock)) {
    return null;
  }

  const latestBlock = await web3Instance.eth.getBlock("latest");
  const remainingBlocks =
    targetBlock - parseInt(latestBlock.number, 10);

  if (remainingBlocks <= 0) {
    return Date.now();
  }

  const avgBlockTimeSeconds = await getAverageBlockTimeSeconds(web3Instance);

  return (
    (parseInt(latestBlock.timestamp, 10) +
      remainingBlocks * avgBlockTimeSeconds) *
    1000
  );
};
